import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function LanguageRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const userLang = navigator.language || navigator.userLanguage;

    if (userLang === "ko-KR" || userLang === "ko") {
      navigate("/kr");
    } else {
      navigate("/en");
    }
  }, [navigate]);

  return null;
}

export default LanguageRedirect;
